import { Button, ImportIcon, Modal } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useClassesTable } from '../../Classes/hooks/useClassesTable';
import { useTimetableStore } from '../../TimetableGrid/TimetableProvider';
import { TimetableVersionImportClasses } from './TimetableVersionImportClasses';

/**
 * Import trigger for the classes data page: a button that opens the class import modal. Lives in the
 * shell's {@link TimetableResourceDataPage} `renderImport` slot because classes — unlike the other
 * resources — import through a dedicated modal rather than a direct connect.
 *
 * Der Oeffnungszustand wird von der Shell gesteuert, damit auch der Button im Leerzustand der
 * Klassentabelle dasselbe Modal oeffnet.
 */
export const TimetableVersionImportClassesButton = observer(
  ({
    versionUuid,
    isOpen,
    onOpenChange,
  }: {
    versionUuid: string;
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
  }) => {
    const { t } = useTranslation();
    const store = useTimetableStore();

    const { data } = useClassesTable();
    const versionClassesUuids = Array.from(store.classes.keys());
    const delta = data.filter((c) => !versionClassesUuids.includes(c.uuid));

    return (
      <>
        <Button
          hierarchy='tertiary'
          disabled={!delta.length || store.readonly}
          icon={<ImportIcon />}
          onClick={() => onOpenChange(true)}
        >
          {t('timetableVersion.import', { import: t('classes.title', { count: 2 }) })}
        </Button>
        <Modal
          isOpen={isOpen}
          onRequestClose={() => onOpenChange(false)}
          shouldCloseOnEsc={false}
          shouldCloseOnOverlayClick={false}
          title={t('timetableVersion.import', { import: t('classes.title', { count: 2 }) })}
          height='l'
        >
          {isOpen && <TimetableVersionImportClasses versionUuid={versionUuid} onClose={() => onOpenChange(false)} />}
        </Modal>
      </>
    );
  },
);
